import React from 'react';
import './Help.css';
import Meta from './Meta';

export default function Help() {
  return (
      <React.Fragment>
      <Meta
        title="Центр поддержки клиентов «ИТ Особа»: инструкции, FAQ и советы"
        description="Инструкции и решения частых проблем, полезные статьи. Не нашли ответ? Обратитесь в техподдержку онлайн."
      />
       <div className="help-container">
      <a
          className="help-link"
          href="/chto_delat_esli_internet_propal"
        >
          Что делать, если интернет пропал? Подробная пошаговая инструкция
        </a>
    </div>
     <div className="help-container">
      <a
          className="help-link"
          href="/priznaki_chto_nuzhen_sistemnyj_administrator"
        >
          5 признаков, что вашему бизнесу срочно нужен системный администратор
        </a>
    </div>
    <div className="help-container">
      <a
          className="help-link"
          href="/ustanavlivaem_videonablyudenie_dlya_dachi"
        >
          Устанавливаем видеонаблюдение для дачи
        </a>
    </div>
    <div className="help-container">
      <a
          className="help-link"
          href="/kak_usilit_signal_wifi_v_kvartire"
        >
          Как усилить сигнал Wi-Fi в квартире: 10 рабочих способов
        </a>
    </div>
    <div className="help-container">
      <a
          className="help-link"
          href="/proektirovanie_sks_fundament_nadezhnoy_infrastruktury_vashego_biznesa"
        >
          Проектирование СКС: Фундамент надежной и эффективной IT-инфраструктуры вашего бизнеса
        </a>
    </div>
    <div className="help-container">
      <a
        className="help-link"
        href="https://itosoba.net/reglament-okaz-uslug-itosoba.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Регламент оказания услуг ООО «ИТ Особа»
      </a>
    </div>
     <div className="help-container">
      <a
        className="help-link"
        href="/price.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Информация о стоимости товаров, услуг и работ ООО «ИТ Особа»
      </a>
    </div>
     <div className="help-container">
      <a
          className="help-link"
          href="/kak_rabotaet_internet"
        >
          Как работает интернет: Просто о сложном для каждого пользователя
        </a>
    </div>
    <div className="help-container">
      <a
          className="help-link"
          href="/statichesky_ili_dinamychesky_ip"
        >
          Статический IP или динамический: что нужно для видеонаблюдения, игр и удаленной работы?
        </a>
    </div>
    </React.Fragment>
  );
}